module.exports = __webpack_public_path__ + "media/images/design/images/icon_fb-c98a5fbe428aa1ed011d90242cb752e0.jpg";